import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { THEME } from '../../../../../../themes';

export const TimePeriodContainer = styled.div<{font:FlattenSimpleInterpolation}>`
  opacity: ${THEME.OPACITY.MED};
  ${({ font }) => font}
  color: ${THEME.COLORS.PRIMARY_DARK};
`;
